{
  "title": "是否允许访问您的位置？",
  "body": "允许访问您的位置可以帮助我们确认您已到达仓库进行签到",
  "disagree": "拒绝",
  "agree": "同意"
}
